import {Banner} from './Banner'
import {Category} from './Category'
import {Join} from './Join'
import {Discover} from './Discover'
import {Cashback} from './Cashback'
import {Reward} from './Reward'
import {Empty} from './Empty'
import {Blog} from './Blog'
import {Adv} from './Adv'
import {News} from './News'
export const Home=()=>{
    return(
        <div>
     <Banner></Banner>
     <Category></Category>
     <Join></Join>
     <Discover></Discover>
     <Cashback></Cashback>
     <Reward></Reward>
     <Empty></Empty>
     <Blog></Blog>
     <Adv></Adv>
     <News></News>
        </div>
    )
}